// File: packages/i18n/src/types.ts
// Version: 2026.4.1 | ForgeTrack i18n types — imports nothing (cycle-free)

export type Locale =
  | 'en' | 'es' | 'fr' | 'pt-BR' | 'de' | 'it' | 'nl' | 'sv' | 'fi'
  | 'pl' | 'ro' | 'tr' | 'vi' | 'uk' | 'ru'
  | 'zh-CN' | 'zh-TW' | 'ja' | 'ko' | 'hi' | 'he' | 'ar';

export type TextDirection = 'ltr' | 'rtl';
export type TranslationDict = Record<string, unknown>;
export type DictionaryLoaderMap = Partial<Record<Locale, () => TranslationDict | Promise<TranslationDict | { default: TranslationDict }>>>;
export type TranslateFunction = (key: string, params?: Record<string, string | number>) => string;

export const SUPPORTED_LOCALES: Locale[] = [
  'en', 'es', 'fr', 'pt-BR', 'de', 'it', 'nl', 'sv', 'fi',
  'pl', 'ro', 'tr', 'vi', 'uk', 'ru',
  'zh-CN', 'zh-TW', 'ja', 'ko', 'hi', 'he', 'ar',
];

export const DEFAULT_LOCALE: Locale = 'en';

export const RTL_LOCALES: Locale[] = ['he', 'ar'];

export const LOCALE_DISPLAY_NAMES: Record<Locale, string> = {
  en: 'English', es: 'Español', fr: 'Français', 'pt-BR': 'Português',
  de: 'Deutsch', it: 'Italiano', nl: 'Nederlands', sv: 'Svenska', fi: 'Suomi',
  pl: 'Polski', ro: 'Română', tr: 'Türkçe', vi: 'Tiếng Việt',
  uk: 'Українська', ru: 'Русский',
  'zh-CN': '简体中文', 'zh-TW': '繁體中文', ja: '日本語', ko: '한국어',
  hi: 'हिन्दी', he: 'עברית', ar: 'العربية',
};

export const LOCALE_SHORT_LABELS: Record<Locale, string> = {
  en: 'EN', es: 'ES', fr: 'FR', 'pt-BR': 'PT', de: 'DE', it: 'IT',
  nl: 'NL', sv: 'SV', fi: 'FI', pl: 'PL', ro: 'RO', tr: 'TR', vi: 'VI',
  uk: 'UK', ru: 'RU', 'zh-CN': '中简', 'zh-TW': '中繁', ja: 'JA', ko: 'KO',
  hi: 'HI', he: 'HE', ar: 'AR',
};

/** Grouped by script family for the LanguageSwitcher */
export const LOCALE_GROUPS = {
  latin: ['en', 'es', 'fr', 'pt-BR', 'de', 'it', 'nl', 'sv', 'fi', 'pl', 'ro', 'tr', 'vi'] as Locale[],
  cyrillic: ['uk', 'ru'] as Locale[],
  cjk: ['zh-CN', 'zh-TW', 'ja', 'ko'] as Locale[],
  indic: ['hi'] as Locale[],
  rtl: ['he', 'ar'] as Locale[],
};

export function getDirection(locale: Locale): TextDirection {
  return RTL_LOCALES.includes(locale) ? 'rtl' : 'ltr';
}

export function isRTL(locale: Locale): boolean {
  return RTL_LOCALES.includes(locale);
}
